<template>
  <div>
    <component class="mt-20 container" ref="fromRef" :is="componentType[curStatus]" :pdfFile="pdfFile"></component>
  </div>
</template>

<script>
const modulesFiles = require.context('./viewFile', false, /\.vue$/)
let _res = {}
modulesFiles.keys().forEach(item => {
  let comp = modulesFiles(item)
  _res[comp.default.name] = comp.default
})
console.log(_res);
export default {
  name: "previewDetail",
  components: { ..._res },
  
  props: {
    curStatus: {
      type: String,
      default: '' 
    },
    // 组件传值
    pdfFile: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      componentType: {
        'doc': 'previewDoc',
        'pdf': 'previewPdf',
        'xls': 'previewWord',
      }
    };
  },
  methods: {},
};
</script>
